import React from 'react';
import { StepIcon, StepNumber } from './StepIcon';
import clsx from 'clsx';
import { getStatusText } from '@/helpers/staticText';
import { ApiReportStepStatus, ApiReportStep } from '@/api/types/models.types';
import useWindowSize from '@/hooks/use-window-size';
import { APP_COLORS } from '@/config/colors';

export interface StatusStepProps {
  step: ApiReportStep;
  isActive: boolean;
  isLast?: boolean;
  progress: number;
  currentStep: number;
}

export const StatusStep: React.FC<StatusStepProps> = ({
  step,
  isActive,
  isLast = false,
  progress,
  currentStep,
}) => {
  const { isMobile } = useWindowSize();

  return (
    <div className="flex w-full items-start gap-7 md:max-w-[202px] md:flex-col md:first-of-type:ml-0 md:first-of-type:pl-0">
      <div className="flex w-full flex-1 flex-col items-center gap-[22px] md:flex-row">
        <StepIcon step={step.order as StepNumber} currentStep={currentStep} />
        {!isLast && (
          <div className="relative w-[28px] flex-1 translate-x-[1.5px] rotate-90 md:w-[104px] md:rotate-0">
            <div
              className="absolute left-0 top-0 h-1 w-full rounded-[50px]"
              style={{ backgroundColor: APP_COLORS.gray[300] }}
            />
            {progress > 0 && (
              <div
                className={clsx(
                  'absolute left-0 top-0 h-1',
                  step.order < currentStep
                    ? 'rounded-[50px] bg-green'
                    : 'rounded-l-[50px] bg-blue',
                )}
                style={{ width: `${progress}%` }}
              />
            )}
          </div>
        )}
      </div>
      <div className="flex w-full flex-col-reverse items-start gap-2 md:flex-col md:gap-5">
        <div className="flex w-full flex-col items-start gap-2">
          {!isMobile && (
            <span className="font-inter text-xs font-bold uppercase leading-3 tracking-[0.3px] text-grayText">
              Krok {step.order}
            </span>
          )}
          <h3
            className={clsx(
              'w-full font-archivo text-lg font-bold leading-[22px] md:min-h-[44px]',
              isActive ? 'text-text-primary' : 'text-grayText',
            )}
          >
            {getStatusText(`krok ${step.order}` as ApiReportStepStatus)}
          </h3>
        </div>
        <div
          className={clsx(
            'leading-1 gap-[10px] rounded-[5px] px-[10px] py-2 font-inter text-[11px] font-semibold uppercase tracking-[0.5px]',
            step.order < currentStep
              ? 'bg-greenLight text-greenDark'
              : step.order === currentStep
                ? 'bg-blue text-white'
                : 'bg-gray-100 text-gray-800',
          )}
        >
          {isMobile && <> Krok {step.order} - </>}
          {step.order < currentStep
            ? 'Zakończone'
            : step.order === currentStep
              ? 'W trakcie'
              : 'Oczekuje'}
        </div>
      </div>
    </div>
  );
};
